import React from 'react';
import { useSelector } from 'react-redux';
import selectMarkers from 'redux-api/reselect/map';
import Maps from 'theme/charts/maps';

function MapChart({ id, height }) {
  const markers = useSelector((state) => selectMarkers(state, id));

  return <Maps markers={markers} maxHeight={height} />;
}

export default MapChart;
